export const formatSpeaker = (speaker: string, advisorName: string | null, customerName: string | null): string => {
  if (speaker.startsWith('担当者')) {
    return advisorName ?? '担当者';
  }
  if (speaker.startsWith('お客様')) {
    return customerName ? `${customerName}様` : 'お客様';
  }
  return speaker;
};
